module.exports = __webpack_public_path__ + "img/review-loka.48e733b7.png";